import {
  CURRENT_TERMS_VERSION,
  CURRENT_PRIVACY_VERSION,
  UserRole,
  type UserWithProfile,
} from '@klaro7/shared-types';

/**
 * A regular USER needs onboarding (the legal-compliance gate) when:
 *  - their profile has no date of birth, OR
 *  - the accepted Terms version is not the current one, OR
 *  - the accepted Privacy version is not the current one.
 *
 * Professionals/admins are never gated here.
 */
export function needsOnboarding(user: UserWithProfile | null | undefined): boolean {
  if (!user) return false;
  if (user.role !== UserRole.USER) return false;

  if (!user.profile?.dateOfBirth) return true;
  if (user.consents?.termsVersion !== CURRENT_TERMS_VERSION) return true;
  if (user.consents?.privacyVersion !== CURRENT_PRIVACY_VERSION) return true;

  return false;
}
